<div class="video-viewer-wrapper">
  <!-- Toolbar -->
  <div class="viewer-toolbar">
    <span class="viewer-title">
      <mat-icon>movie</mat-icon>
      Video
      <span *ngIf="fileName" class="file-name">— {{ fileName }}</span>
    </span>
  </div>

  <!-- Player container -->
  <div class="player-container">
    <video *ngIf="videoSrc && !loadError" [src]="videoSrc" controls autoplay playsinline class="video-player"></video>

    <!-- Loading spinner -->
    <div *ngIf="isLoading" class="overlay">
      <mat-spinner
        diameter="56"
        [mode]="loadProgress !== null ? 'determinate' : 'indeterminate'"
        [value]="loadProgress ?? 0"
      ></mat-spinner>
      <p>Loading video{{ loadProgress !== null ? ' — ' + loadProgress + '%' : '…' }}</p>
    </div>

    <!-- Error message -->
    <div *ngIf="loadError" class="overlay error-overlay">
      <mat-icon class="error-icon">{{ sizeExceeded ? 'warning' : 'error_outline' }}</mat-icon>
      <p>{{ loadError }}</p>
    </div>
  </div>
</div>
